<template>
    <div>
        <!-- <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-3">
                    <label>Status</label>
                     <multiselect 
                        v-model="status" 
                        placeholder="Select status" 
                        :options="statusList"  
                        :multiple="true" 
                        @input="search"
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <label>Ecn</label>
                     <multiselect 
                        v-model="ecn" 
                        placeholder="Select ecn" 
                        :options="['IBP','TWD','TMC']"  
                        :multiple="true" 
                        @input="search"
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-2">
                    <button @click="clear()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="search()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div> -->
          <!-- <div class="abs-btn-grp form-group col-sm-3">
            <form @submit.prevent="" class="d-inline-flex mt-0 ml-4">
              <i @click="search()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
              <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
              <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
            </form>
          </div> -->
                    <div class="card vh-75" id="scroll">
                        <h3 class="m-3">MSRB Trades</h3>
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <!-- <th 
                                    scope="col" 
                                    class="sort"
                                     >Cusip</th> -->
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >QTY</th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >TRADE DATE</th> 
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >ID Trade</th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Customer Sold</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Customer Bot</th>  
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >YIELD</th>   
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="msrbList.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in msrbList" :key="data.id">
                                <!-- <td class="text-wrap"><span class="cusips">{{data.cusip}}</span></td> -->
                                <td class="text-center">{{data.quantity}}</td>
                                <td class="text-center">
                                    {{data.tradeDate ? moment(data.tradeDate).format("MM/DD/YYYY"): 'N/A'}}
                                </td>
                                <td class="text-center"><span v-if="data.idcPrice">{{data.idcPrice | currency }}</span></td>
                                <td class="text-center"><span v-if="data.soldPrice">{{data.soldPrice | currency }}</span></td>
                                <td class="text-center"><span v-if="data.botPrice">{{data.botPrice | currency}}</span></td>
                                <td class="text-center">{{data.yield}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getMsrbList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>    
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
  name: "msrbComponent",
  components : {
    
  },
  props :["cusipId"],
  watch: { 
    cusipId: function() { // watch it
          this.getMsrbList();
        }
      },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        msrbList : [],
        showFilters : false,
     
    };
  },
  methods: {
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getMsrbList();
    },
    search(){
        this.currentPage = 1;
        this.getMsrbList();  
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 1;
        this.getMsrbList();  
    },
    clear(){
        this.searchValue = "";
        this.currentPage = 1;
        this.getMsrbList();  
    },
    getMsrbList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/msrb-trades?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.cusipId +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.msrbList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    }
   
  },
  mounted() {
    this.getMsrbList();
  }
};
</script>